import type { SurveyConfig } from "../../api";
import { newId } from "../../api";

/** A ready-made 5-question intake survey with functional tags attached to answers. Fully editable after loading. */
export function starterSurvey(cfg: SurveyConfig): SurveyConfig {
  const q = (prompt: string, answerType: string, required: boolean, opts: [string, string[]][]) => {
    const options = opts.map(([label, attached_tags]) => {
      const id = newId();
      return { id, label, attached_tags };
    });
    return { id: newId(), prompt, answerType, required, options };
  };

  const questions = [
    q("What's the main reason you're looking right now?", "single_select", true, [
      ["We have a specific problem to fix today", ["targeted-solution"]],
      ["Preventing a breach or incident", ["threat-prevention", "incident-response"]],
      ["Cutting cost or consolidating tools", ["cost-reduction", "tool-consolidation"]],
      ["Freeing up my team's time", ["efficiency", "automation"]],
      ["An audit, regulation or insurer requirement", ["compliance", "audit-ready"]],
    ]),
    q("Which of these sound familiar?", "multi_select", false, [
      ["Too many alerts to keep up with", ["alert-fatigue", "efficiency"]],
      ["We had a security incident recently", ["incident-response", "threat-prevention"]],
      ["We pay for overlapping tools", ["cost-reduction", "tool-consolidation"]],
      ["Our cyber insurance renewal asked hard questions", ["compliance", "cyber-insurance"]],
      ["Nobody watches for threats after hours", ["24-7-coverage", "understaffed"]],
    ]),
    q("Who handles security today?", "single_select", true, [
      ["No one dedicated, IT covers it", ["understaffed", "managed-services"]],
      ["One or two people", ["understaffed"]],
      ["A small security team", ["sec-ops"]],
      ["An outside provider (MSP or MSSP)", ["partner-management", "cost-reduction"]],
    ]),
    q("Do you have a compliance deadline in the next 12 months?", "single_select", true, [
      ["Yes", ["compliance"]],
      ["No", []],
      ["Not sure", ["compliance-review"]],
    ]),
    q("Anything specific you want to see?", "short_text", false, []),
  ];

  return {
    ...cfg,
    surveyEnabled: true,
    surveyIntro: cfg.surveyIntro || "A few quick questions so the tour focuses on what matters to you.",
    questions: [...cfg.questions, ...questions],
  };
}
